import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // make sure this is imported
import { Colors } from "../../ColorConstants";
import Button from "../Buttons";

ReactModal.setAppElement("#root"); // Adjust selector to your app root

const PhoneNumberPopup = ({
  open,
  onClose,
  mobileNo,
  onNumberChange,
  onSubmitPhone,
}) => {
  return (
    <ReactModal
      isOpen={open}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      contentLabel="Enter phone number"
      style={{
        content: {
          height: "15rem",
          maxWidth: "25rem",
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 999,
        },
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        <div style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
          Phone Number
        </div>
        <div style={{ fontSize: "14px" }}>
          Enter your phone number, including country code
        </div>
        <StyledPhoneInput
          placeholder="Enter phone number"
          defaultCountry="QA"
          value={mobileNo}
          onChange={onNumberChange}
        />
        <div style={{ height: "16px" }}></div>
        <Button
          disabled={!mobileNo}
          variant="filled"
          onClick={onSubmitPhone}
          label={"Submit"}
        />
      </div>
    </ReactModal>
  );
};

const StyledPhoneInput = styled(PhoneInput)`
  input {
    border: 1px solid #ccc;
    padding: 0.7rem;
    border-radius: 0.25rem;
    font-family: "Poppins", sans-serif;
    font-size: 0.8125rem;
    line-height: 0.75rem;
    color: ${Colors.secondaryBlack};
    width: 100%; // ensure input is wide enough
  }
`;

export default PhoneNumberPopup;
